import { Link } from 'react-router-dom';
import { popularComics } from '@/mocks/comics';

export default function PopularComics() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">万众瞩目的热门漫画，不容错过</p>
          </div>
          <Link
            to="/category/rexue"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {popularComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4]">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 非常爱漫画免费在线看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-primary-500 text-white text-xs font-medium">
                  {comic.rating}
                </div>
                {comic.status === '连载中' && (
                  <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-white text-xs font-medium">
                    连载
                  </div>
                )}
                <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <span className="text-white text-xs bg-primary-500/90 px-3 py-1.5 rounded-lg whitespace-nowrap">
                    立即阅读
                  </span>
                </div>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-1">{comic.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}